export const environment = {
  production: true,
  stripePublishableKey:
    'pk_live_51L8oP9EEjjmOkP1YORHzV3yDmXdx6tXwXCVtPidSAJAFIqgflkrNaGGyOfm1LukdUQDFeMfFiIqCo6KoiJMjkRJZ00gwhagz9k',
  stripeTestMode: null,
  firebaseConsoleWebAPIKey: 'AIzaSyD-KwnGf6evywmoihEyIHuQ4C-ikNIUwnk',
};
